export const MULTISELECT = 'MULTISELECT';
export const SELECT = 'SELECT';
export const AREA = 'AREA';
export const MIN_MAX = 'MIN_MAX';
export const TEXT = 'TEXT';
export const AUTOCOMPLETE = 'AUTOCOMPLETE';
export const DATE_RANGE = 'DATE_RANGE';
export const DATA_STREAM_MIN_MAX = 'DATA_STREAM_MIN_MAX';
export const DATA_STREAM_MULTISELECT = 'DATA_STREAM_MULTISELECT';
export const DATA_STREAM_DATE_RANGE = 'DATA_STREAM_DATE_RANGE';
export const TITLE = 'TITLE';

export const DYNAMIC_FILTERS = [
  MULTISELECT,
  SELECT,
  MIN_MAX,
  DATE_RANGE,
  DATA_STREAM_MIN_MAX,
  DATA_STREAM_MULTISELECT,
  DATA_STREAM_DATE_RANGE,
];
